import {
  ADMIN_FETCH_COWS_REQUEST,
  ADMIN_FETCH_COWS_SUCCESS,
  ADMIN_FETCH_COWS_FAIL,
  ADMIN_FETCH_COW_REQUEST,
  ADMIN_FETCH_COW_SUCCESS,
  ADMIN_FETCH_COW_FAIL,
  ADMIN_ADD_COW_REQUEST,
  ADMIN_ADD_COW_SUCCESS,
  ADMIN_ADD_COW_FAIL,
  ADMIN_UPDATE_COW_REQUEST,
  ADMIN_UPDATE_COW_SUCCESS,
  ADMIN_UPDATE_COW_FAIL,
  ADMIN_DELETE_COW_REQUEST,
  ADMIN_DELETE_COW_SUCCESS,
  ADMIN_DELETE_COW_FAIL,
  ADMIN_REGISTER_REQUEST,
  ADMIN_REGISTER_SUCCESS,
  ADMIN_REGISTER_FAIL,
  ADMIN_CLEAR_REGISTRATION,
  ADMIN_SET_ANIMAL_SORT,
  ADMIN_REG_CONFIRM_REQUEST,
  ADMIN_REG_CONFIRM_SUCCESS,
  ADMIN_REG_CONFIRM_FAIL,
  ADMIN_SET_COW_PAGE,
  ADMIN_SET_COW_PAGE_SIZE,
  ADMIN_SET_PWD_REQUEST,
  ADMIN_SET_PWD_SUCCESS,
  ADMIN_SET_PWD_FAIL,
  ADMIN_UPDATE_PWD_REQUEST,
  ADMIN_UPDATE_PWD_SUCCESS,
  ADMIN_UPDATE_PWD_FAIL,
  ADMIN_SET_FILTER_ATTR,
  ADMIN_SET_FILTER_OPERATOR,
  ADMIN_SET_FILTER_VALUE
  // ADMIN_SAVE_ANIMAL_DOC,
  // ADMIN_SAVE_ANIMAL_DOC_SUCCESS,
  // ADMIN_SAVE_ANIMAL_DOC_FAIL,
  // ADMIN_DELETE_ANIMAL_DOC,
  // ADMIN_DELETE_ANIMAL_DOC_SUCCESS,
  // ADMIN_DELETE_ANIMAL_DOC_FAIL
} from './constants';

export const fetchAnimals = () => ({
  type: ADMIN_FETCH_COWS_REQUEST
});
export const fetchAnimalsSuccess = (animals, scoreDefinitions) => ({
  type: ADMIN_FETCH_COWS_SUCCESS, animals, scoreDefinitions
});
export const fetchAnimalsFail = error => ({
  type: ADMIN_FETCH_COWS_FAIL, error
});
export const fetchAnimal = id => ({
  type: ADMIN_FETCH_COW_REQUEST, id
});
export const fetchAnimalSuccess = (animal, scoreDefinitions) => ({
  type: ADMIN_FETCH_COW_SUCCESS, animal, scoreDefinitions
});
export const fetchAnimalFail = (error, id) => ({
  type: ADMIN_FETCH_COW_FAIL, error, id
});
export const addAnimal = (
  animal, cloudFilesToRemove = [], redirectUrl = null
) => ({
  type: ADMIN_ADD_COW_REQUEST, animal, cloudFilesToRemove, redirectUrl
});
export const addAnimalSuccess = animal => ({
  type: ADMIN_ADD_COW_SUCCESS, animal
});
export const addAnimalFail = (error, animal) => ({
  type: ADMIN_ADD_COW_FAIL, error, animal
});
export const updateAnimal = (animal, cloudFilesToRemove = []) => ({
  type: ADMIN_UPDATE_COW_REQUEST, animal, cloudFilesToRemove
});
export const updateAnimalSuccess = animal => ({
  type: ADMIN_UPDATE_COW_SUCCESS, animal
});
export const updateAnimalFail = (error, animal) => ({
  type: ADMIN_UPDATE_COW_FAIL, error, animal
});
export const deleteAnimal = (animal, cloudFilesToRemove = []) => ({
  type: ADMIN_DELETE_COW_REQUEST, animal, cloudFilesToRemove
});
export const deleteAnimalSuccess = animal => ({
  type: ADMIN_DELETE_COW_SUCCESS, animal
});
export const deleteAnimalFail = (error, animal) => ({
  type: ADMIN_DELETE_COW_FAIL, error, animal
});
export const registerUser = registration => ({
  type: ADMIN_REGISTER_REQUEST, registration
});
export const registerUserSuccess = () => ({
  type: ADMIN_REGISTER_SUCCESS
});
export const registerUserFail = (error, registration) => ({
  type: ADMIN_REGISTER_FAIL, error, registration
});
export const clearRegistration = () => ({
  type: ADMIN_CLEAR_REGISTRATION
});
export const setAdminAnimalSort = sort => ({
  type: ADMIN_SET_ANIMAL_SORT, sort
});
export const confirmRegistration = (authCode, id) => ({
  type: ADMIN_REG_CONFIRM_REQUEST, authCode, id
});
export const confirmRegistrationSuccess = () => ({
  type: ADMIN_REG_CONFIRM_SUCCESS
});
export const confirmRegistrationFail = () => ({
  type: ADMIN_REG_CONFIRM_FAIL
});
export const setAnimalPage = page => ({
  type: ADMIN_SET_COW_PAGE, page
});
export const setAnimalPageSize = size => ({
  type: ADMIN_SET_COW_PAGE_SIZE, size
});
export const setNewPassword = (authCode, id, password) => ({
  type: ADMIN_SET_PWD_REQUEST, authCode, id, password
});
export const setNewPasswordSuccess = () => ({
  type: ADMIN_SET_PWD_SUCCESS
});
export const setNewPasswordFail = error => ({
  type: ADMIN_SET_PWD_FAIL, error
});
export const updatePassword = (email, existingPassword, newPassword) => ({
  type: ADMIN_UPDATE_PWD_REQUEST, email, existingPassword, newPassword
});
export const updatePasswordSuccess = () => ({
  type: ADMIN_UPDATE_PWD_SUCCESS
});
export const updatePasswordFail = error => ({
  type: ADMIN_UPDATE_PWD_FAIL, error
});
export const setFilterAttribute = filterAttribute => ({
  type: ADMIN_SET_FILTER_ATTR, filterAttribute
});
export const setFilterOperator = filterOperator => ({
  type: ADMIN_SET_FILTER_OPERATOR, filterOperator
});
export const setFilterValue = filterValue => ({
  type: ADMIN_SET_FILTER_VALUE, filterValue
});
